import { makeStyles, Theme } from '@material-ui/core/styles';


export const useRootStyles = makeStyles((theme: Theme) => ({ 
    root: {
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        width: '95%',
        minWidth: 120,
    },
}));

interface inputFieldsProps {
    variant: 'standard' | 'outlined' | 'filled';
}

export const defaultInputProps: inputFieldsProps = {
    variant: "standard",
};

interface inputDateProps {
    variant: 'dialog' | 'inline' | 'static';
}

export const defaultDateProps: inputDateProps = {
    variant: "inline",
};

